import * as paths from "routes/paths";
import { urls } from "routes/urls";

interface ProfileLocationState {
	// set on an agent profile opened from the Featured Listings page's MLS IDs tab; the Team page leaves it unset,
	// and a new tab, a pasted link or a bookmark starts without it
	fromFeaturedMlsIds?: boolean;
}

// An agent's profile, opened from the MLS IDs tab, so its back link returns there.
export const profileFromFeaturedMlsIds = (agentId: number) => {
	const state: ProfileLocationState = { fromFeaturedMlsIds: true };
	return { pathname: urls.settingsAgentById(agentId), state };
};

// Where the profile's back link goes. The Featured Listings page opens on its MLS IDs tab.
export const profileBackLink = (state: unknown) =>
	(state as ProfileLocationState | undefined)?.fromFeaturedMlsIds
		? { label: "Back to Featured Listings", path: paths.settingsListingResults }
		: { label: "Back to Team", path: paths.settingsAgents };
